import { useState } from 'react';
import ReusableDataTable from '../../components/ReusableDataTable';
// import CertificateDetails from './certificate_details';
import BackdropModal from '../../components/modals/backdrop_modal';
import apiRequest from '../../services/apiService';
import TechOathDetails from './techoath_details';

const pk = "transaction_id";

const columns = [
    { id: 'transaction_id',     field: 'transaction_id',        headerName: 'TRANSACTION ID' },
    { id: 'transaction_status', field: 'transaction_status',    headerName: 'STATUS' },
    { id: 'transaction_type', field: 'transaction_type',    headerName: 'TYPE' },

    
    { id: 'first_name',     field: 'first_name',    headerName: 'FIRST' },
    { id: 'middle_name',    field: 'middle_name',   headerName: 'MIDDLE' },
    { id: 'last_name',      field: 'last_name',     headerName: 'LAST' },
];


// List of fields that are date fields
const columns_date = ['date_created'];


// List of fields that has status
const columns_status = ['user_status'];


const actions = [
    { label: 'Edit', link: './update', icon: 'bx bx-edit-alt me-1' },
];

const other_actions = [
     { label: 'Activate', link: '/delete', icon: 'bx bx-detail me-1' },
];

const fetchData  = async ({ page, rowsPerPage, sortBy, sortOrder, searchTerm }) => {
    const params = {
        page     : page,
        page_size: rowsPerPage,
        ordering : sortBy ? `${sortOrder === 'desc' ? '-' : ''}${sortBy}`: undefined,
        search   : searchTerm || undefined,
        transaction_status   : "PENDING",
    };

    

    return await apiRequest('GET', '/transactions/', null, params);
};








const TechOathTable = ({sendNotification}) => {

    const deleteEndpoint = `${process.env.REACT_APP_API_URL}/transactions`;
    const [selectedItem, setSelectedItem] = useState(null);

    const handleViewDetails = (item) => {
        console.log(item);
        setSelectedItem(item);
        setOpen(true);
    };

    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    const handleSave = () => {
        handleClose();
    };


    const handleActivate = (row,todo) => {
        console.log(row);
     }

     const handleDelete = (transaction_id) => {
        console.log(transaction_id);
      };
    


     const getStatusWithColor = (column, value) => {
        if (columns_status.includes(column)) {
            const statusColors = {
                activated  : 'badge bg-label-success',
                pending    : 'badge bg-label-warning',
                deactivated: 'badge bg-label-danger',
            };

         
            const color = statusColors[value] || 'white';
            return (
                <span className={color}>
                    {value}
                </span>
            );
        }
        return value; // For other columns, return the value as is
    };


    const generateRowActions = (row) => {
        let button_title="";

        if(row.techOath_status.toLowerCase() === "activated"){
            button_title="Deactivate";
        }
        else if(row.techOath_status.toLowerCase() === "deactivated"){
            button_title="Activate";
        }
        else if(row.techOath_status.toLowerCase() === "pending"){
            button_title="Approve";
        }
        else{
            button_title="";
        }


        return (
            button_title &&
                <div>
                    <button className='dropdown-item' onClick={() => handleActivate(row)}><i className='bx bx-detail me-1'></i>{button_title} Account</button>
                </div>
        );
    };

    return (
        <>
            <ReusableDataTable
                fetchDataFn    = {fetchData}
                columns        = {columns}
                
                actions        = {actions}
                // other_actions  = {generateRowActions}
                other_actions  = ""

                onViewDetails  = {handleViewDetails}
                deleteEndpoint = {deleteEndpoint}
                tableTitle     = 'List of Transactions'
                primarykey     = {pk}
                handleActivate={handleActivate}

                columns_date   = {columns_date}
                cellStylingFn={getStatusWithColor}

                
                
            />

            <BackdropModal  open={open} handleClose={handleClose} handleSave={handleSave} modalTitle="Information" >
                <TechOathDetails selectedItem={selectedItem} sendNotification={sendNotification} handleDelete={handleDelete} />
            </BackdropModal>
        </>
    );
}

export default TechOathTable;